import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { FIND_TRIPS_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { FIND_TRIPS_REPORT } from "../interfaces/dashboard";

export default function FindTrips() {
    const findTripsReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.FIND_TRIPS_REPORT;

    const [findTripsReportTableData, setFindTripsReportTableData] = useState<FIND_TRIPS_REPORT[]>([]);

    useEffect(() => {
        setFindTripsReportTableData(FIND_TRIPS_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType='Find Trips'
        tableColumns={findTripsReportTableColumns}
        tableData={findTripsReportTableData} />
    );
}